const siteRouter = {
  route: null,
  name: null,
  title: '站点设置',
  type: 'folder',
  icon: 'iconfont icon-rizhiguanli',
  isElementIcon: false,
  filePath: 'view/site/',
  order: 3,
  inNav: true,
  permission: ['获取站点配置'],
  children: [
    {
      title: '基础配置',
      type: 'view',
      name: 'SiteConfig',
      route: '/site/config',
      filePath: 'view/site/site-config.vue',
      inNav: true,
      icon: 'iconfont icon-rizhiguanli',
      isElementIcon: false,
      permission: ['获取站点配置'],
    },
    {
      title: '景区导航设置',
      type: 'view',
      name: 'SiteScenicNavigation',
      route: '/site/scenic-navigation',
      filePath: 'view/site/scenic-navigation.vue',
      inNav: true,
      icon: 'iconfont icon-rizhiguanli',
      isElementIcon: false,
      permission: ['景区导航设置列表'],
    },
  ],
}

export default siteRouter
